import React from "react";
import "./SectionIcon.scss";

export type SectionIconTone = "coral" | "blue";

export interface SectionIconProps {
  icon: React.ComponentType<{ size?: string; className?: string }>;
  size?: "xxs" | "xs" | "sm" | "default" | "lg" | "xl";
  tone?: SectionIconTone;
  className?: string;
}

export default function SectionIcon({
  icon: Icon,
  size = "sm",
  tone = "coral",
  className = "",
}: SectionIconProps) {
  const toneClass = tone === "blue" ? "section-icon--blue" : "section-icon--coral";
  return (
    <span className={`section-icon ${toneClass} ${className}`.trim()} aria-hidden>
      <Icon size={size} className="section-icon__svg" />
    </span>
  );
}
